<template>
  <div>
    <div v-if="appSavitarna" :class="wraperClass"><slot /></div>
    <v-alert v-if="!appSavitarna" dense outlined type="error"><slot /></v-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElSavitarnaAlert',
  props: {
    classP: { type: String, default: '' },
    type: String,
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    isSavitarna() {
      return this.appSavitarna
    },
    wraperClass() {
      return `alert-wraper ${this.typeClass} ${this.classP}`
    },
    typeClass() {
      return `alert-${this.type}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';

.alert-wraper {
  padding: 17px 6px 14px 59px;
  background-repeat: no-repeat;
  background-position: 14px 8px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 1em;
  margin-top: 1em;

  &.alert-error {
    background-color: #fff6f6;
    border-color: #d20000;
    background-image: url('/static/message-error-small.png');
  }
  &.alert-warning {
    background-color: #fffdf6;
    border-color: #f4ca00;
    background-image: url('/static/message-info2-small.png');
  }
  &.alert-warning2 {
    background-color: #fffdf6;
    border-color: #f4ca00;
    background-image: url('/static/message-warning-small.png');
  }
  &.alert-info {
    background-color: #fafafa;
    border-color: #d0d0d0;
    background-image: url('/static/message-info2-small.png');
  }
}
</style>
